import $ from 'jquery'

$(() => {
  const $field = $('.field-password')
  if ($field.length < 1) return

  const $strength = $('.pw-strength')
  const $label = $('.pw-strength_label')

  if ($strength.attr('data-pw-strength') === undefined) {
    $strength.attr('data-pw-strength', 'is-empty')
    $label.text('')
  }

  // lazy load `zxcvbn` lib
  import('zxcvbn').then(({ default: zxcvbn }) => {
    $field.on('keyup', function () {
      const value = $(this).val()

      if (value !== '') {
        const result = zxcvbn(value)

        switch (result.score) {
          case 0:
            $strength.attr('data-pw-strength', 'is-veryweak')
            $label.text('Very weak') // TODO: Make these... a little more playful.
            break
          case 1:
            $strength.attr('data-pw-strength', 'is-weak')
            $label.text('Weak')
            break
          case 2:
            $strength.attr('data-pw-strength', 'is-fair')
            $label.text('Fair')
            break
          case 3:
            $strength.attr('data-pw-strength', 'is-good')
            $label.text('Good')
            break
          case 4:
            $strength.attr('data-pw-strength', 'is-strong')
            $label.text('Strong')
            break
        }
      } else {
        $strength.attr('data-pw-strength', 'is-empty')
        $label.text('')
      }
    })
  })
})
